import React from 'react';
import styled from 'styled-components';
import { MdOutlineEventAvailable } from 'react-icons/md';
import dayjs from 'dayjs';
import dayjsBusinessDays from 'dayjs-business-days';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

import sharedStyles from '../styles';

dayjs.extend(dayjsBusinessDays);

const calculateDeliveryDayFrom = () =>
  dayjs().businessDaysAdd(3).format('MMMM D');

const calculateDeliveryDayTo = () => {
  const today = dayjs();
  const deliveryDate = today.businessDaysAdd(5);
  // compare to see if date range falls within same month
  const formatString =
    deliveryDate.month() !== dayjs().businessDaysAdd(3).month()
      ? 'MMMM D'
      : 'D';
  return deliveryDate.format(formatString);
};

const StyledContainer = styled.li`
  margin: ${sharedStyles.spacing['spacing-md']} 0;
  display: flex;
  gap: ${sharedStyles.spacing['spacing-1xs']};
`;

const IconContainer = styled.div`
  color: ${({ theme }) => theme.colors.brandPrimary};
  width: 1.15rem;
  height: 1.15rem;
`;

const TextColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  line-height: 1.15;
  p {
    margin: 0;
  }
`;

function DeliveryIndicator() {
  const { tt } = useUiComponentsInternationalContext();
  return (
    <StyledContainer>
      <IconContainer>
        <MdOutlineEventAvailable size={19} />
      </IconContainer>
      <TextColumn>
        <p>
          {tt(s => s.productCommon.orderToReceiveBetweenDates, {
            orderToday: <b>{tt(s => s.productCommon.orderToday)}</b>,
            from: calculateDeliveryDayFrom(),
            to: calculateDeliveryDayTo(),
          })}
        </p>
      </TextColumn>
    </StyledContainer>
  );
}

export default DeliveryIndicator;
